/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-02 16:49:07
 * @modify date 2021-09-02 16:49:07
 * @desc 直播活动
 */
import lodash from 'lodash';
import { computed } from 'mobx';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../helpers/ajaxBasics';
import { BaseModel, BasesController } from '../bases';
export class LiveController<T = any> extends BasesController<T> {
  constructor() {
    super();
    this.reset({
      dataKey: 'id',
      infinite: true,
      pagination: EnumAPI.content_promotion_activity,
      details: EnumAPI.content_live_details,
      paginationParams: {
        currentKey: 'curPageNo',
        pageSizeKey: 'pageSize',
        filterKey: 'search',
        response: {
          dataSource: 'data',
          total: 'total',
        },
      },
    });
  }
  /**
   * 值存储
   * @memberof MaterialsController
   */
  Model = new BaseModel({ type: 'object' });
  /**
   * @dec 促销活动
   */
  @computed
  get promotionActivity(): Array<any> {
    return this.Model.get('promotionActivity', []);
  }
  /**
   * @dec 直播活动
   */
  @computed
  get liveActivity(): Array<any> {
    return this.Model.get('liveActivity', []);
  }

  /**
   * 首页促销活动
   */
  async getPromotionActivity(type?) {
    const pageSize = type || 5;
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.content_promotion_activity,
        body: {
          curPageNo: 1,
          pageSize,
        },
      });
      this.Model.merge({ promotionActivity: lodash.get(res, 'data') });
    } catch (error) {}
  }
  /**
   * 首页直播活动
   */
  async getLiveActivity() {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.content_live_activity,
        body: {
          curPageNo: 1,
          pageSize: 5,
        },
      });
      this.Model.merge({ liveActivity: lodash.get(res, 'data') });
    } catch (error) {}
  }

  /**
   * 解析状态
   * @param {*} entity
   * @return {*}
   * @memberof LiveController
   */
  parsesStartStatus(entity) {
    return lodash.get(
      { '0': '即将开始', '1': '进行中', '-1': '已结束' },
      entity.actStartStatus,
    );
  }
  /**
   * 商品
   * @readonly
   * @memberof LiveController
   */
  @computed
  get Product(): Array<IProduct> {
    return this.Details.Model.getStorage('product', []);
  }
  /**
   * 海报
   * @readonly
   * @memberof LiveController
   */
  @computed
  get Posters(): Array<IPosters> {
    return this.Details.Model.getStorage('posters', []);
  }
  /**
   * 活动商品
   * @memberof LiveController
   */
  async getProduct(body) {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.content_live_product,
        body,
      });
      this.Details.Model.setStorage('product', res);
    } catch (error) {}
  }
  /**
   * 分享码信息
   * @param id
   * @returns
   */
  getScene(id) {
    return AjaxBasics.request({ ...EnumAPI.content_live_scene, body: { id } });
  }
  /**
   * 进入直播间统计
   * @param activityId
   * @returns
   */
  setAccessLiveBroadcastingRoom(activityId) {
    return AjaxBasics.request({
      ...EnumAPI.content_live_statistics,
      body: { activityId },
    });
  }
  /**
   * 活动海报
   * @memberof LiveController
   */
  async getPosters(body) {
    try {
      const res = await AjaxBasics.request({
        ...EnumAPI.content_live_posters,
        body,
      });
      this.Details.Model.setStorage('posters', res);
    } catch (error) {}
  }
  /**
   * 合成下载图片
   * @memberof LiveController
   */
  async getDownPosters(id) {
    return AjaxBasics.request({
      ...EnumAPI.content_live_posters_down,
      body: { id },
    });
  }
  /**
   * 太阳码下载
   * @memberof LiveController
   */
  async getQrCordDownPosters(id) {
    return AjaxBasics.request({
      ...EnumAPI.content_live_posters_qrCodeDown,
      body: { id },
    });
  }

  /**
   * isg推广活动 活动报名
   * @memberof LiveController
   */
  async isgSignUp(activityId) {
    return AjaxBasics.request({
      ...EnumAPI.content_isg_signUp,
      body: { activityId },
    });
  }
  /**
   * isg推广活动 取消活动报名
   * @memberof LiveController
   */
  async isgCancelSignUp(activityId) {
    return AjaxBasics.request({
      ...EnumAPI.content_isg_cancel_signUp,
      body: { activityId },
    });
  }
  /**
   * isg推广活动 是否已报名
   * @memberof LiveController
   */
  async isgActivityEnroll(activityId) {
    return AjaxBasics.request({
      ...EnumAPI.content_isg_activity_enroll,
      body: { activityId },
    });
  }
  /**
   * isg推广活动 获取参与信息
   * @memberof LiveController
   */
  async isgParticipationInfo(activityId) {
    return AjaxBasics.request({
      ...EnumAPI.content_isg_participation_info,
      body: { activityId },
    });
  }
}
interface IProduct {
  activityId: string;
  category: string;
  configInfo: string;
  dealerId: string;
  goodsName: string;
  picture: string;
  price: string;
  priceList: any;
  productName: string;
  specsInfo: string;
}
interface IPosters {
  id: string;
  owner: string;
  picUrl: string;
  posterName: string;
  posterOrder: string;
  posterUrl: string;
  promoCode: string;
  promoId: string;
}
